"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelStatementListExportTask = cancelStatementListExportTask;
exports.createStatementExportTask = createStatementExportTask;
exports.createStatementListExportTask = createStatementListExportTask;
exports.createStatementOrderExportTask = createStatementOrderExportTask;
exports.deleteStatementExportTask = deleteStatementExportTask;
exports.downloadFileByPath = downloadFileByPath;
exports.getStatementExportQueueDetail = getStatementExportQueueDetail;
exports.getStatementExportRecordList = getStatementExportRecordList;
exports.getStatementExportTaskDetail = getStatementExportTaskDetail;
exports.getStatementExportTaskList = getStatementExportTaskList;
exports.getStatementExportTaskStatus = getStatementExportTaskStatus;
exports.getStatementListExportTaskDetail = getStatementListExportTaskDetail;
exports.getStatementListExportTaskList = getStatementListExportTaskList;
exports.stopStatementListExportTask = stopStatementListExportTask;
var _request = _interopRequireDefault(require("@/utils/request"));
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * 对账单导出任务相关API
 */
var BASE_URL = '/admin/merchant/statement';

/**
 * 创建对账单导出任务
 * @param {Object|String} params - 对账单ID或参数对象
 */
function createStatementExportTask(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/export/create"),
    method: 'post',
    data: params
  });
}

/**
 * 创建账单明细订单导出任务
 * @param {Object} params - { statementId, statementNo, orderSearchRequest }
 */
function createStatementOrderExportTask(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/export/statement-order"),
    method: 'post',
    data: params
  });
}

/**
 * 按当前列表筛选条件创建对账单导出任务
 * @param {Object} params 不包含 page、limit 的列表筛选条件
 */
function createStatementListExportTask(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/export/list/create"),
    method: 'post',
    data: params
  });
}

/**
 * 查询对账单列表导出任务详情
 * 轮询请求跳过网络异常的全局提示，由任务组件统一控制重试提示频率
 * @param {String|Number} taskId
 */
function getStatementListExportTaskDetail(taskId) {
  return (0, _request.default)({
    url: "/admin/download/task/".concat(taskId),
    method: 'get',
    __skipGlobalErrorMessage: true
  });
}

/**
 * 取消排队中的对账单列表导出任务
 * @param {String|Number} taskId
 */
function cancelStatementListExportTask(taskId) {
  return (0, _request.default)({
    url: "/admin/download/task/queue/cancel/".concat(taskId),
    method: 'post'
  });
}

/**
 * 中止执行中的对账单列表导出任务
 * @param {String|Number} taskId
 */
function stopStatementListExportTask(taskId) {
  return (0, _request.default)({
    url: "/admin/download/task/stop/".concat(taskId),
    method: 'post'
  });
}

/**
 * 查询对账单列表导出记录
 * @param {Object} params 分页和可选筛选条件
 */
function getStatementListExportTaskList(params) {
  return (0, _request.default)({
    url: '/admin/download/task/list',
    method: 'post',
    data: _objectSpread(_objectSpread({}, params), {}, {
      taskType: 'MERCHANT_STATEMENT_LIST_EXPORT'
    })
  });
}

/**
 * 获取对账单导出任务列表
 * @param {Object} params
 */
function getStatementExportTaskList(params) {
  return (0, _request.default)({
    url: '/admin/download/task/list',
    method: 'post',
    data: _objectSpread({
      taskType: 'MERCHANT_STATEMENT_EXPORT'
    }, params)
  });
}

/**
 * 获取指定对账单ID下的导出记录列表
 * @param {Object} params - { statementId, page, limit }
 */
function getStatementExportRecordList(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/export/record/list"),
    method: 'get',
    params: params
  });
}

/**
 * 删除对账单导出任务
 * @param {String|Number} taskId
 */
function deleteStatementExportTask(taskId) {
  return (0, _request.default)({
    url: "/admin/download/task/delete/".concat(taskId),
    method: 'post'
  });
}

/**
 * 下载导出文件
 * @param {String} filePath
 * @param {String} fileName
 */
function downloadFileByPath(filePath, fileName) {
  orderListApi.downloadFileByPath(filePath, fileName);
}

/**
 * 查询导出任务状态
 * @param {String|Number} taskId
 */
function getStatementExportTaskStatus(taskId) {
  return orderListApi.getDownloadTaskStatus(taskId);
}

/**
 * 查询导出任务详情
 * @param {String|Number} taskId
 */
function getStatementExportTaskDetail(taskId) {
  return orderListApi.getDownloadTaskDetail(taskId);
}

/**
 * 查询导出排队详情
 * @param {String} taskType
 */
function getStatementExportQueueDetail(taskType) {
  return orderListApi.getDownloadQueueDetail(taskType);
}